<template>
    <transition name="zoom" mode="out-in">
        <div class="modalInfo" v-if="isModalOpened" :key="modalId">
            <div v-if="!modalForAdmin">
                <i class="fas fa-times" @click="handleModal(0)" title="Fermer"></i>
                
                <h2>Je rencontre un problème avec le jeu</h2>

                <p>Veille à ce que ton bloqueur de publicité soit désactivé, il empêche le bon fonctionnement de nos contenus. Utilise un navigateur récent comme Google Chrome, Mozilla Firefox ou Microsoft Edge et assure-toi qu'il soit à jour. Jette un œil à ton antivirus qui pourrait bloquer le script d'un de nos jeux.</p>
                <p>Si le problème persiste, contacte-nous via notre <a href="https://clicktestcps.fr/contact/" target="_blank">formulaire en ligne</a> en précisant dans le message la nature du problème.</p>
                <br />

                <h2>Je souhaite jouer aux jeux depuis mon téléphone</h2>

                <p>Il est possible de jouer à tes jeux favoris sur Games™ depuis ton téléphone. La majorité de nos jeux est optimisée pour une expérience sur smartphone. Veille à avoir une connexion internet suffisante et à utiliser le mode « plein écran » pour une meilleure visibilité.</p>
                <br />

                <h2>Je veux soumettre une idée de jeux à ajouter</h2>
                <p>Il est possible de nous soumettre un jeu que tu apprécies pour que nous l'ajoutions à notre catalogue. Pour cela, c'est également sur notre <a href="https://clicktestcps.fr/contact/" target="_blank">formulaire de contact</a> que ça se passe. Précise que ton message est une "suggestion de jeu" et le nom exact du jeu en question.</p>
            </div>
            <div v-if="modalForAdmin">
                <i class="fas fa-times" @click="handleModal(0, 'ban')" title="Fermer"></i>

                <h2>Exclure l'utilisateur {{ commentRelatedInBan.pseudo }}</h2>

                <div class="radio-container">
                    <input type="radio" id="temp" value="temp" v-model="banDuration" />
                    <label for="temp">Temporairement</label><br>
                </div>
                
                <label for="banDay">Jour</label>
                <input id="banDay" type="date" :value="inputBanDay" @input="inputBanDay= $event.target.value" :disabled="banDuration != 'temp'" />

                <label for="banHour">Heure</label>
                <input id="banHour" type="time" :value="inputBanHour" @input="inputBanHour= $event.target.value" :disabled="banDuration != 'temp'" />

                <div class="radio-container">
                    <input type="radio" id="perm" value="perm" v-model="banDuration" />
                    <label for="perm">Définitivement</label><br>
                </div>

                <div class="radio-container">
                    <input type="radio" id="false" value="false" v-model="banDuration" />
                    <label for="false">Débannir</label><br>
                </div>
                
                <hr/>
                <label for="banReason">Raison du ban</label>
                <input id="banReason" type="text" :value="inputBanReason" @input="inputBanReason= $event.target.value" :class="{ border: erreurRaisonBan }" :disabled="banDuration == 'false'" />
                <p v-if="erreurRaisonBan">{{ erreurRaisonBan }}</p>

                <button @click="banVisitor">Valider</button>
            </div>
        </div>
    </transition>

    <transition name="fadeModalOverlay" mode="out-in">
        <div class="modalOverlay" v-if="isModalOpened" :key="modalId" @click="handleModal(0, 'ban')"></div>
    </transition>

    <transition name="fade">
        <p v-if="alert" :key="alert" :class="(fullScreen ? 'popup-message-fullscreen' : 'popup-message')">{{ alert }}</p>
    </transition>
    
    <template v-if="!$store.state.waitingRequest">
        <main>
            <h1>{{ title }}</h1>
            <p class="viewCount" v-if="view_count">Joué {{ view_count }} fois <i></i></p>
            
            <section class="gameSection">
                <div class="game">
                    <div class="player" :class="(fullScreen ? 'fullscreen-player' : '')">
                        <transition name="fade">
                            <div class="player-overlay" :style="{'background-image' : 'url(\'static/miniatures/' + image_url +'\')'}" v-if="!iframeLoaded"></div>
                        </transition>
                        <transition name="fade">
                            <div class="play-game" v-if="!iframeLoaded" :style="[fullScreen ? {'min-width' : '200px'} : {'min-width' : '100px'}]">
                                <div class="img"><div class="background" :style="{'background-image' : 'url(\'static/miniatures/' + image_url + '\')'}"></div></div>
                                <a href="#" @click.prevent="loadIframe">Jouer</a>
                            </div>
                        </transition>
                        <iframe :src="iframeLoaded ? iframe_url : '//'" :key="iframeLoaded ? iframe_url : '//'" scrolling="none" frameborder="0"></iframe>
                    </div>
                    <div :class="'buttons ' + (fullScreen ? 'fullscreen-buttons' : '')">
                        <div class="left">
                            <div class="moreInfo" @click="handleModal(1)"><i class="fas fa-question-circle"></i><span>Plus d'information</span></div>
                        </div>
                        <div class="right">
                            <div class="like">
                                <svg @click="likeGame" :class="(isGameLiked ? 'active-like' : '')" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="m1.75 23h2.5c.965 0 1.75-.785 1.75-1.75v-11.5c0-.965-.785-1.75-1.75-1.75h-2.5c-.965 0-1.75.785-1.75 1.75v11.5c0 .965.785 1.75 1.75 1.75z"/>
                                    <path d="m12.781.75c-1 0-1.5.5-1.5 3 0 2.376-2.301 4.288-3.781 5.273v12.388c1.601.741 4.806 1.839 9.781 1.839h1.6c1.95 0 3.61-1.4 3.94-3.32l1.12-6.5c.42-2.45-1.46-4.68-3.94-4.68h-4.72s.75-1.5.75-4c0-3-2.25-4-3.25-4z"/>
                                </svg>
                                <span>{{ likesCount }} %</span>
                            </div>

                            <div class="dislike">
                                <svg @click="dislikeGame" :class="(isGameDisliked ? 'active-dislike' : '')" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="m22.25 1h-2.5c-.965 0-1.75.785-1.75 1.75v11.5c0 .965.785 1.75 1.75 1.75h2.5c.965 0 1.75-.785 1.75-1.75v-11.5c0-.965-.785-1.75-1.75-1.75z"/>
                                    <path d="m5.119.75c-1.95 0-3.61 1.4-3.94 3.32l-1.12 6.5c-.42 2.45 1.46 4.68 3.94 4.68h4.72s-.75 1.5-.75 4c0 3 2.25 4 3.25 4s1.5-.5 1.5-3c0-2.376 2.301-4.288 3.781-5.273v-12.388c-1.601-.741-4.806-1.839-9.781-1.839z"/>
                                </svg>
                                <span>{{ dislikesCount }} %</span>
                            </div>

                            <div class="vertical-separation"></div>
                            <i :class="'fas fa-heart ' + (isGameFavorite ? 'active-heart' : '')" @click="setFavoriteGame"></i>
                            <i :class="'fas ' + (fullScreen ? 'fa-compress' : 'fa-expand')" @click="fullScreen = !fullScreen"></i>
                        </div>
                    </div>
                    <div class="description">
                        {{ description }}
                    </div>
                    <div class="tags">
                        <span v-for="tag in tags" :key="tag">{{ tag }}</span>
                    </div>
                    
                    <div class="ad-banner">
                        <ins class="adsbygoogle"
                        data-ad-client="ca-pub-2512331316053279"
                        data-ad-slot="6346220535"></ins>
                        <div class="background">PUBLICITÉ</div>
                    </div>

                    <div class="comments-section">
                        <div class="comments-count">Commentaires ({{ commentsNb }}) | Que penses-tu de ce jeu ?</div>
                        <div class="add-comment">
                            <div class="form">
                                <p class="overlay-message" v-if="banReason && disabledUntil == null">Tu as été banni définitivement pour le motif suivant : "{{ banReason }}"</p>
                                <p class="overlay-message" v-if="disabledUntil != null">Tu as été banni temporairement jusqu'au {{ dateFr(disabledUntil) }} pour le motif suivant : "{{ banReason }}"</p>
                                <p class="overlay-message" v-if="commentTimeLeft">{{ commentTimeLeft }}</p>

                                <div class="form-overlay" v-if="commentDisabled"></div>

                                <p v-if="erreurPseudo">{{ erreurPseudo }}</p>
                                <input type="text" placeholder="Ton pseudo" :value="pseudo" @input="changePseudo" @focus="erreursPseudo" @keyup="erreursPseudo" :disabled="commentDisabled || userConnected" :class="{ border: erreurPseudo }" />
                                
                                <p v-if="erreurMessage">{{ erreurMessage }}</p>
                                <div class="bottom">
                                    <textarea placeholder="Ton message..." :value="message" @input="message= $event.target.value" @focus="erreursMessage" @keyup="erreursMessage" :disabled="commentDisabled" :class="{ border: erreurMessage }" spellcheck="false"></textarea>
                                    <button @click="validation" :disabled="commentDisabled">
                                        <svg viewBox="0 0 512 512"><path d="M481.508,210.336L68.414,38.926c-17.403-7.222-37.064-4.045-51.309,8.287C2.86,59.547-3.098,78.551,1.558,96.808 L38.327,241h180.026c8.284,0,15.001,6.716,15.001,15.001c0,8.284-6.716,15.001-15.001,15.001H38.327L1.558,415.193 c-4.656,18.258,1.301,37.262,15.547,49.595c14.274,12.357,33.937,15.495,51.31,8.287l413.094-171.409 C500.317,293.862,512,276.364,512,256.001C512,235.638,500.317,218.139,481.508,210.336z"></path></svg>
                                    </button>
                                    
                                    <input type="text" placeholder="Autre (laisser vide)" :value="autre" @input="autre= $event.target.value" class="autre" autocomplete="false" />
                                </div>
                            </div>
                            <div class="text">
                                <h3>Échange avec la communauté</h3>
                                <p>Donne ton avis sur le jeu, demande de l'aide ou partage ton score !</p>
                                <p>Pas besoin de compte pour la publication de commentaires, mais si tu souhaites avoir une expérience personnalisée et simplifiée, <router-link to="/register">crée dès maintenant un compte</router-link> pour y retrouver toutes tes infos !</p>
                            </div>
                        </div>
                        <div class="all-comments">
                            <div class="comment-container" v-for="comment in comments" :key="comment.id">
                                <div class="comment">
                                    <div class="top">
                                        <div class="pseudo">
                                            <span class="member-badge" title="Membre de Games™" v-if="comment.member_id != null"><i class="fas fa-user-alt"></i></span>
                                            <p>{{ comment.pseudo }}</p>
                                            <a href="#" title="Supprimer" @click.prevent="deleteComment(comment.id)" v-if="ipAddress == comment.sender_ip || adminConnected"><i class="fas fa-ban"></i></a>
                                            <a href="#" :title="'Exclure ' + comment.pseudo" @click.prevent="handleModal(1, 'ban', comment)" v-if="adminConnected" :style="[comment.banned != 'false' ? {'background-color' : '#fa4b4b'} : {'background-color' : '#2e2963'}]"><i class="fas fa-user-times"></i></a>
                                        </div>
                                        <p class="ago">{{ timeAgo(new Date(comment.created_at.replace(/-/g, '/'))) }}</p>
                                    </div>
                                    <p>{{ comment.message }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="see-more" v-if="comments.length < commentsNb" @click="displayMoreComments">Afficher plus</div>
                    </div>
                </div>
                <div class="other-games">
                    <div class="jeu-container" v-for="unJeu in lesJeux" :key="unJeu.id">
                        <div class="jeu">
                            <div class="ribbon-new-container" v-if="(((nowDate.getTime()/1000 - (new Date(unJeu.created_at.replace(/-/g, '/')).getTime()/1000))/3600).toFixed(2)) <= 72.00">
                                <div class="ribbon-new">NOUVEAU</div>
                            </div>
                            
                            <router-link :to="'/' + unJeu.title_url" :title="unJeu.title">
                                <div class="img"><div class="background" :style="{'background-image' : 'url(\'/games/static/miniatures/' + unJeu.image_url + '\')'}"></div></div>
                                <div class="contenu">
                                    <p>{{ unJeu.title }}</p>
                                    <span>Joué {{ unJeu.view_count }} fois</span>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </template>
    <template v-else>
        <SkeletonJeu />
    </template>
</template>

<script>
import LocalDb from '../mixins/localdb';
import AddGoogleScripts from '../mixins/addGoogleScripts';
import SkeletonJeu from '../components/SkeletonJeu.vue';

export default {
    name: 'Jeu',
    mixins: [LocalDb, AddGoogleScripts],
    components: {
        SkeletonJeu
    },
    data() {
        return {
            nowDate: null,
            nbRequests: 0,
            userConnected: false,
            memberId: null,
            
            iframeLoaded: false,
            fullScreen: false,
            lesJeux: [],
            isGameFavorite: false,
            alert: '',
            alertId: 0,
            interval: null,
            secondsLeft: 4,
            isGameLiked: false,
            isGameDisliked: false,
            likesCount: 0,
            dislikesCount: 0,

            isModalOpened: false,
            modalId: 0,
            
            id: '',
            title: '',
            description: '',
            title_url: '',
            iframe_url: '',
            image_url: '',
            tags: [],
            id_categorie: '',
            view_count: '',
            
            commentSent: false,
            commentInterval: null,
            commentTimeLeft: '',
            commentDisabled: false,
            disabledUntil: null,
            spamDeadline: null,
            banReason: '',
            pseudo: '',
            message: '',
            autre: '',
            erreurPseudo: '',
            erreurMessage: '',
            comments: [],
            commentsNb: 0,
            displayCommentsFrom: 0,
            displayCommentsUntil: 8,
            ipAddress: '',

            adminConnected: false,
            modalForAdmin: false,
            commentRelatedInBan: null,
            banDuration: 'temp',
            erreurRaisonBan: '',
            inputBanReason: '',
            inputBanDay: '',
            inputBanHour: '',
            
            metas : {
                title: 'Joue gratuitement en ligne | Games par ClickTestCPS',
                meta: [
                    {
                        name: 'description',
                        content: 'Jouez à des centaines de jeux en ligne sur Games™ par ClickTestCPS.fr ! Une sélection unique de jeux en ligne gratuits alimentée quotidiennement. Jeux de Clickers, Jeux d’Action, Jeux de Réflexion ou encore Jeux de Course, vous pouvez être sûr que vous trouverez votre bonheur ici.'
                    },
                    {
                        name: 'keywords',
                        content: 'ClickTestCPS.fr games, ClickTestCPS games, Jeux clicktestcps, jeux en ligne, jeux en ligne gratuit, jeux en ligne entre amis, jeux en ligne multijoueur, jeux en ligne pc, jeux en ligne jeu, jeu en ligne, jeux à deux en ligne, jeux en ligne fille, jeux en ligne cp, jeux en ligne switch, rocket league en ligne, nouveaux jeux en ligne '+new Date().getFullYear()+', jeu en ligne à plusieurs, action ou vérité jeu en ligne, jeu en ligne maternelle, jeu en ligne adulte, jeu en ligne 6 ans, site de jeu en ligne, jeux. fr, jeux .fr, jeu en ligne mario, jeu en ligne mac, jeu en ligne téléphone, jeu en ligne de voiture, jeu en ligne de clic, jeu en ligne de clique, jeu en ligne ce2, jeu à boire en ligne, jeu en ligne 3000, où est charlie jeu en ligne, jeu en ligne io, jeu en ligne bebe, jeu en ligne foot '+new Date().getFullYear()+', jeu en ligne cheval, jeu en ligne escape game, jeu en ligne youtube, jeu en ligne influenceurs, jeu en ligne uno, jeu en ligne streamers, jeu en ligne vidéo, jeu en ligne simulation, jeu en ligne multiplication, jeu en ligne fdj, jeu en ligne sur pc, jeux en ligne sur pc, online games, online free games, online free games without login, jeu en ligne guerre, jeu en ligne iphone, jeu en ligne question pour un champion, jeu en ligne battle royale, jeu en ligne rpg, jeu en ligne minecraft, jeu en ligne kohi, jeu en ligne fps, jeu en ligne rapide, jeu en ligne et gratuit, jeu online, jeu avec chat en ligne, jeu en ligne loup garou, jeu en ligne quizz, jeu de quizz, jeu en ligne couple, jeu en ligne culture générale, jeu en ligne barbie, jeu en ligne français'
                    },
                    {
                        property: 'og:image',
                        content: 'https://clicktestcps.fr/og-games.png'
                    },
                    {
                        property: 'og:title',
                        content: 'Jeux en ligne gratuits en un clic - Jeu FR '+new Date().getFullYear()+' sans inscription - Games™ par ClickTestCPS'
                    },
                    {
                        property: 'og:description',
                        content: 'Jouez à des centaines de jeux en ligne gratuitement et sans inscription. Une sélection unique de jeux en ligne gratuits alimentée quotidiennement'
                    }
                ]
            }
        }
    },
    mounted() {
        useHead(this.metas);
        this.$store.commit('setRequestTrue');
        
        this.getGame();

        window.addEventListener('keyup', e => {
            if (e.key == "Escape") {
                if(this.isModalOpened) {
                    this.handleModal(0, 'ban');
                }
            }
        });
        
        this.nowDate = new Date();
    },
    methods: {
        getGame() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                gameTitle: this.$route.params.gameTitle
            }));
            
            axios
            .post(this.$store.state.apiUrl+"?request=getGame", formData)
            .then((response) => {
                if(response.data.id) {
                    this.id = response.data.id;
                    this.title = response.data.title;
                    this.description = response.data.description;
                    this.title_url = response.data.title_url;
                    this.iframe_url = response.data.iframe_url;
                    this.image_url = response.data.image_url;
                    this.tags = response.data.tags.split(",").map(item=>item.trim());
                    this.id_categorie = response.data.id_categorie;
                    
                    if (document.querySelector(".menu-"+this.id_categorie)!=null) {
                        document.getElementsByClassName("menu-"+this.id_categorie).item(0).classList.add('active');
                        this.$store.commit('setActiveMobileLink', this.id_categorie);
                    }
                    
                    this.setMetas();
                    this.getVisitorInfos();
                    this.checkStorage();
                    this.updateVisitDate();
                    this.getSuggestionGames();
                }
                else {
                    this.$router.push('/');
                }
            })
            .finally(() => {
                this.nbRequests++;
            });
        },
        setMetas() {
            this.metas.title = this.title + ' - Joue gratuitement en ligne | Games par ClickTestCPS';
            this.metas.meta[0].content = this.description;
        },
        getVisitorInfos() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({post: "1"}));
            
            axios
            .post(this.$store.state.apiUrl+"?request=getVisitorInfos", formData)
            .then((response) => {
                if(response.data.id) {
                    this.ipAddress = response.data.ip_address;

                    if(response.data.banned == 'false') {
                        this.spamDeadline = response.data.spam_deadline;
                        this.timerAbleToComment();
                    } else if(response.data.banned == 'temp') {
                        let expiration = new Date(response.data.banned_until.replace(/-/g, '/'));
                        let difference = expiration.getTime() - this.nowDate.getTime();
                        let minutesLeft = Math.round(difference / 60000);
                        
                        if(minutesLeft > 0) {
                            this.commentDisabled = true;

                            this.disabledUntil = new Date(response.data.banned_until.replace(/-/g, '/'));
                            this.banReason = response.data.ban_reason;
                        }
                        else {
                            this.spamDeadline = response.data.spam_deadline;
                            this.timerAbleToComment();
                        }
                    }
                    else {
                        this.commentDisabled = true;
                        this.banReason = response.data.ban_reason;
                    }
                }
            })
            .finally(() => {
                this.nbRequests++;
                this.checkSession();
                this.getCommentsNb();
            });
        },
        timerAbleToComment() {
            this.checkAbleToComment();
            this.commentInterval = setInterval(() => { this.checkAbleToComment() }, 30000);
        },
        checkAbleToComment() {
            let now = new Date();
            let expiration = new Date(this.spamDeadline.replace(/-/g, '/'));
            let difference = expiration.getTime() - now.getTime();
            let minutesLeft = Math.round(difference / 60000);
            let minute = minutesLeft > 1 ? "minutes" : "minute";
            
            if (minutesLeft > 0) {
                this.commentDisabled = true;
                this.commentTimeLeft = "Tu pourras de nouveau envoyer un message dans " + minutesLeft + " " + minute;
            } else {
                this.commentDisabled = false;
                this.commentTimeLeft = '';
                clearInterval(this.commentInterval);
                this.commentSent = false;
            }
        },
        getCommentsNb() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                gameId: this.id
            }));
            
            axios
            .post(this.$store.state.apiUrl+"?request=getCommentsNb", formData)
            .then((response) => {
                if(response.data) {
                    this.commentsNb = response.data;
                }
            })
            .finally(() => {
                this.nbRequests++;
                this.getAccountLogin();
                this.getComments();
            });
        },
        getAccountLogin() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({post: "1"}));
            
            axios.post(this.$store.state.apiUrl+"?request=getSessionData", formData, { withCredentials: true })
            .then((response) => {
                if(response.data) {
                    this.pseudo = response.data.identifiant;
                    this.memberId = response.data.id;
                    this.userConnected = true;
                } else {
                    this.pseudo = '';
                    this.memberId = null;
                    this.userConnected = false;
                }
            }).finally(() => {
                this.nbRequests++;
            });
        },
        getComments() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                gameId: this.id,
                displayCommentsFrom: this.displayCommentsFrom,
                displayCommentsUntil: this.displayCommentsUntil
            }));
            
            axios
            .post(this.$store.state.apiUrl+"?request=getComments", formData)
            .then((response) => {
                if(response.data) {
                    if(this.displayCommentsFrom == 0) {
                        this.comments = response.data;
                    } else {
                        this.comments = [ ...this.comments, ...response.data ];
                    }
                }
            })
            .finally(() => {
                this.nbRequests++;
            });
        },
        changePseudo(e) {
            if(!this.userConnected) {
                this.pseudo = e.target.value;
            }
        },
        displayMoreComments() {
            this.displayCommentsFrom = this.comments.length;
            this.displayCommentsUntil = 8;
            this.getComments();
        },
        checkSession() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({post: "1"}));
            
            axios
            .post(this.$store.state.apiUrl+"?request=checkSession", formData, { withCredentials: true })
            .then((response) => {
                if(response.data == 'admin') {
                    this.adminConnected = true;
                }
            });
        },
        dateFr(date) {
            function handleZeros(nbr, type = '') {
                nbr = (type == 'mm') ? nbr++ : nbr;
                let string = (nbr < 10) ? ('0' + nbr.toString()) : (nbr.toString());
                return string;
            }

            let dd = handleZeros(date.getDate());
            let mm = handleZeros(date.getMonth()+1, 'mm');
            let yyyy = handleZeros(date.getFullYear());

            let hh = handleZeros(date.getHours());
            let ii = handleZeros(date.getMinutes());

            return dd + '/' + mm + '/' + yyyy + ' à ' + hh + ':' + ii;
        },
        timeAgo(time) {
            let interval;
            let intervalType;

            let seconds = Math.floor((new Date() - time.getTime()) / 1000);

            interval = Math.floor(seconds / 86400);
            if (interval >= 1) {
                intervalType = 'j';
            } else {
                interval = Math.floor(seconds / 3600);
                if (interval >= 1) {
                    intervalType = "h";
                } else {
                    interval = Math.floor(seconds / 60);
                    if (interval >= 1) {
                        intervalType = "m";
                    } else {
                        interval = seconds;
                        intervalType = "s";

                        if(interval < 0) {
                            interval = 0;
                        }
                    }
                }
            }

            return interval + ' ' + intervalType;
        },
        checkStorage() {
            this.getLikesDislikesCount();
            
            /* Vérification des jeux joués */
            this.db_playedGames.getItem(this.id.toString()).then((data) => {
                // Si le jeu actuel a déjà été joué
                if(data) {
                    this.displayViewCount();
                    
                    /* Si le jeu actuel a déjà été mis en favori */
                    if(data.favorite) {
                        this.isGameFavorite = true;
                    }

                    /* Si le jeu actuel a été aimé ou non */
                    if(data.liked) {
                        this.isGameLiked = true;
                    } else if(data.disliked) {
                        this.isGameDisliked = true;
                    }
                    
                    data.played_at = new Date();
                    this.db_playedGames.setItem(this.id.toString(), data);
                }
                // Si le jeu actuel n'a pas encore été joué
                else {
                    this.incrementViewCount();
                    this.db_playedGames.setItem(this.id.toString(), {played_at: new Date(), favorite: false, liked: false, disliked: false});
                }
            });
        },
        incrementViewCount() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                id: this.id
            }));

            axios
            .post(this.$store.state.apiUrl+"?request=updateViewCount", formData)
            .then((response) => {
                if(response) {
                    this.displayViewCount();
                }
            });
        },
        displayViewCount() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                id: this.id
            }));

            axios
            .post(
            this.$store.state.apiUrl+"?request=getViewCount", formData
            )
            .then((response) => {
                if(response.data) {
                    this.view_count = response.data;
                }
            });
        },
        getLikesDislikesCount() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                id: this.id
            }));

            axios
            .post(this.$store.state.apiUrl+"?request=getLikesDislikesCount", formData)
            .then((response) => {
                if(response.data) {
                    let likesNb = parseInt(response.data.likes_count);
                    let dislikesNb = parseInt(response.data.dislikes_count);
                    let totalLikesDislikes = likesNb + dislikesNb;

                    this.likesCount = Math.round(likesNb * 100 / totalLikesDislikes);
                    this.dislikesCount = Math.round(dislikesNb * 100 / totalLikesDislikes);
                }
            });
        },
        updateVisitDate() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                id: this.id
            }));

            axios
            .post(this.$store.state.apiUrl+"?request=updateVisitDate", formData)
            .finally(() => {
                this.nbRequests++;
            });
        },
        getSuggestionGames() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                except: this.$route.params.gameTitle,
                categoryId: this.id_categorie
            }));
            
            axios
            .post(this.$store.state.apiUrl+"?request=getSuggestionGames", formData)
            .then((response) => {
                if(response.data.length > 0) {
                    this.lesJeux = response.data;
                }
            })
            .finally(() => {
                this.nbRequests++;
            });
        },
        loadIframe() {
            this.iframeLoaded = true;
        },
        likeGame() {
            this.alertId++;
            let setLike = false;
            clearInterval(this.interval);
            
            if(this.isGameLiked) {
                setLike = false;
                this.alert = "Tu n'aimes plus " + this.title;
            }
            else {
                setLike = true;
                this.alert = "Tu aimes " + this.title;
            }
            
            this.db_playedGames.getItem(this.id.toString()).then((data) => {
                data.liked = setLike;
                data.disliked = false;
                this.db_playedGames.setItem(this.id.toString(), data);
            });

            this.isGameLiked = setLike;

            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                id: this.id,
                gameLiked: this.isGameLiked,
                gameDisliked: this.isGameDisliked
            }));
            
            axios
            .post(this.$store.state.apiUrl+"?request=updateLikes", formData)
            .then((response) => {
                if(response.data) {
                    this.getLikesDislikesCount();
                }
            })
            .finally(() => {
                this.isGameDisliked = false;
            });
        },
        dislikeGame() {
            this.alertId++;
            let setDislike = false;
            clearInterval(this.interval);
            
            if(this.isGameDisliked) {
                setDislike = false;
                this.alert = "Tu as retiré " + this.title + " des jeux que tu n'aimais pas";
            }
            else {
                setDislike = true;
                this.alert = "Tu n'aimes pas " + this.title;
            }
            
            this.db_playedGames.getItem(this.id.toString()).then((data) => {
                data.liked = false;
                data.disliked = setDislike;
                this.db_playedGames.setItem(this.id.toString(), data);
            });

            this.isGameDisliked = setDislike;

            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                id: this.id,
                gameLiked: this.isGameLiked,
                gameDisliked: this.isGameDisliked
            }));
            
            axios
            .post(this.$store.state.apiUrl+"?request=updateDislikes", formData)
            .then((response) => {
                if(response.data) {
                    this.getLikesDislikesCount();
                }
            })
            .finally(() => {
                this.isGameLiked = false;
            });
        },
        setFavoriteGame() {
            this.alertId++;
            let setFavorite = false;
            clearInterval(this.interval);
            
            if(this.isGameFavorite) {
                setFavorite = false;
                this.alert = this.title + ' a été retiré des favoris.';
            }
            else {
                setFavorite = true;
                this.alert = this.title + ' a été ajouté en favori.';
            }

            this.db_playedGames.getItem(this.id.toString()).then((data) => {
                data.favorite = setFavorite;
                this.db_playedGames.setItem(this.id.toString(), data);
            });

            this.isGameFavorite = setFavorite;
        },
        alertTimer() {
            this.secondsLeft--;
            if(this.secondsLeft == 1) {
                this.alert = '';
                clearInterval(this.interval);
            }
        },
        handleModal(action, origin = '', comment = null) {
            // Si la boîte doit être ouverte
            if(action == 1) {
                this.isModalOpened = true;

                if(origin == 'ban') {
                    this.modalForAdmin = true;
                    this.commentRelatedInBan = comment;

                    function handleZeros(nbr) {
                        let string = (nbr < 10) ? ('0' + nbr.toString()) : (nbr.toString());
                        return string;
                    }

                    let date = new Date();
                    this.inputBanDay = date.getFullYear() + '-' + handleZeros(date.getUTCMonth()+1) + '-' + date.getDate();
                    this.inputBanHour = handleZeros(date.getHours()) + ':' + date.getMinutes();
                }
            } else {
                this.isModalOpened = false;

                if(origin == 'ban') {
                    this.modalForAdmin = false;
                }
            }
            this.modalId++;
        },
        pseudoValide() {
            let valide = false;

            if(!this.userConnected) {
                if (this.pseudo && this.pseudo.trim() && this.pseudo.length >= 3 && this.pseudo.length <= 16) {
                    valide = true;
                }
            } else {
                valide = true;
            }

            return valide;
        },
        messageValide() {
            let valide = false;

            if (this.message && this.message.trim() && this.message.length >= 3 && this.message.length <= 144) {
                valide = true;
            }
            return valide;
        },
        erreursPseudo() {
            this.erreurPseudo = "";

            if (!this.pseudoValide()) {
                if (!this.pseudo || !this.pseudo.trim()) {
                    this.erreurPseudo = "Le pseudo est requis.";
                } else {
                    if (this.pseudo.length < 3) {
                        this.erreurPseudo = "Le pseudo doit comporter au moins 3 caractères.";
                    } else if (this.pseudo.length > 16) {
                        this.erreurPseudo = "Le pseudo ne doit pas dépasser 16 caractères.";
                    }
                }
            }
        },
        erreursMessage() {
            this.erreurMessage = "";
            
            if (!this.messageValide()) {
                if (!this.message || !this.message.trim()) {
                    this.erreurMessage = "Le message est requis.";
                } else {
                    if (this.message.length < 3) {
                        this.erreurMessage = 'Le message doit comporter au moins 3 caractères.';
                    } else if (this.message.length > 144) {
                        this.erreurMessage = "Le message ne doit pas dépasser 144 caractères.";
                    }
                }
            }
        },
        validation() {
            if (this.commentDisabled == false) {
                if (this.pseudoValide() && this.messageValide() && !this.autre) {
                    this.envoiMessage();
                } else {
                    this.erreursPseudo();
                    this.erreursMessage();
                }
            }
        },
        envoiMessage() {
            if(this.commentSent == false) {
                let formData = new FormData();
                formData.append('data', JSON.stringify({
                    post: "1",
                    commentId: this.id,
                    pseudo: this.pseudo,
                    message: this.message,
                    memberId: this.memberId
                }));
                
                axios
                .post(this.$store.state.apiUrl+"?request=addComment", formData)
                .then((response) => {
                    if(response.data) {
                        this.getVisitorInfos();
                        this.timerAbleToComment();
                        
                        this.displayCommentsFrom = 0;
                        this.displayCommentsUntil = 8;
                    }
                })
                .finally(() => {
                    this.commentSent = true;
                    this.getCommentsNb();
                });
            }
        },
        deleteComment(commentId) {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                commentId: commentId
            }));

            axios
            .post(this.$store.state.apiUrl+"?request=deleteComment", formData)
            .then((response) => {
                if(response.data) {
                    this.displayCommentsFrom = 0;
                    this.displayCommentsUntil = this.comments.length;
                    this.getCommentsNb();
                }
            });
        },
        banVisitor() {
            let ok = false;

            if(this.banDuration == 'false') {
                ok = true;
            } else {
                if (this.inputBanReason && this.inputBanReason.trim()) {
                    ok = true;
                } else {
                    this.erreurRaisonBan = 'La raison du ban est requise';
                }
            }

            if(ok) {
                let formData = new FormData();
                formData.append('data', JSON.stringify({
                    post: "1",
                    userIp: this.commentRelatedInBan.sender_ip,
                    banDuration: this.banDuration,
                    bannedUntil: this.inputBanDay + ' ' + this.inputBanHour + ':00',
                    banReason: this.inputBanReason
                }));

                axios
                .post(this.$store.state.apiUrl+"?request=banVisitor", formData)
                .then((response) => {
                    if(response.data) {
                        if(this.banDuration != 'false') {
                            this.alert = this.commentRelatedInBan.pseudo + ' a été exclu ' + (this.banDuration == 'perm' ? 'définitivement' : 'temporairement');
                        } else {
                            this.alert = this.commentRelatedInBan.pseudo + ' a été débanni';
                        }

                        this.displayCommentsFrom = 0;
                        this.displayCommentsUntil = this.comments.length;
                        this.getCommentsNb();
                    }
                });
            }
        }
    },
    watch: {
        fullScreen() {
            document.body.style.overflowY = (this.fullScreen ? 'hidden' : 'scroll');
        },
        '$route' (to, from) {
            if (document.querySelector(".menu-"+this.id_categorie)!=null) {
                document.getElementsByClassName("menu-"+this.id_categorie).item(0).classList.remove('active');
                this.$store.commit('setActiveMobileLink', 0);
            }
        },
        nbRequests() {
            if(this.nbRequests == 7) {
                this.$store.commit('setRequestFalse');
            }
        },
        alert() {
            if(this.alert != '') {
                this.secondsLeft = 4;
                this.interval = setInterval(() => { this.alertTimer() }, 1000);
            }
        }
    }
}
</script>

<style scoped src="@/assets/game.css">
</style>
